import React from 'react';
import _ from 'lodash';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { useParameterizedQuery } from 'react-fetching-library';
import moment from 'moment';
import './style.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import RBCToolbar from './RBCToolbar';
import SlotsControlDetails from './SlotsControlDetails';
import { AlertDialogContainer } from '../../../../components/others/AlertDialogContainer';
import { getCalendarDaySlotsAction } from '../../../../services/request';
import { formatDate } from '../../../../services/functions';

require('moment/locale/pl.js');
const localizer = momentLocalizer(moment);

export const CalendarImpl = ({ allActivities, timedSlotsControls, selectedResort }) => {
  const { query } = useParameterizedQuery(getCalendarDaySlotsAction);
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [editRowData, setEditRowData] = React.useState(null);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');

  const [events, setEvents] = React.useState([]);

  React.useEffect(() => {
    const uniqueData = timedSlotsControls.filter((item, index, self) => index === self.findIndex(t => t.start === item.start && t.end === item.end)
    );
    setEvents(uniqueData);
  }, [timedSlotsControls]);

  const handleDayClick = async e => {
    const formattedDate = formatDate(e.start);
    const { payload, error, loading: qLoading } = await query(selectedResort, formattedDate);

    if (!error && !qLoading) {
      console.log(payload);
      if (!payload) {
        setSeverity('error');
        setTitle('Nie znaleziono kontroli miejsc na wybrany dzień');
        setMessage('');
        setShowAlert(true);

        return;
      }
      setEditRowData(payload);
      setOpenCompose(true);
    }
  };

  const submitCallback = payload => {
    setEditRowData(payload);
  };

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <SlotsControlDetails
        isOpenCompose={openCompose}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        data={editRowData}
        allActivities={allActivities}
        selectedResort={selectedResort}
        submitCallback={submitCallback}
      />
      <Calendar
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
        events={events}
        style={{ height: '100vh' }}
        views={['month']}
        messages={{
          next: 'Następny',
          previous: 'Poprzedni',
          today: 'Dzisiaj',
          month: 'Miesiąc',
          week: 'Tydzień',
          day: 'Dzień'
        }}
        components={{ toolbar: props => (<RBCToolbar {...props} handleClick={() => {
          setFullScreen(true);
          setOpenCompose(true);
        }} />) }}
        onSelectSlot={handleDayClick}
        selectable
        endAccessor={({ end }) => new Date(end)}
      />
    </>

  );
};
